export default __webpack_public_path__ + "static/media/pageLoad1.5a943af3.gif";